import cls from "classnames";
import { getLinkFilePreviewTip } from "logic/src/objects/session/sessionFile";
import LinkPopover from "logic/src/components/LinkPopover";
import { ISessionFile } from "logic/src/objects/session/type";
import { ReactComponent as LinkIcon } from "logic/src/components/icons/documents-icon/link.svg";
import { ReactComponent as DeleteIcon } from "logic/src/components/icons/delete.svg";
import CircleIcon from "../icons/circle";
import styles from "./index.module.scss";

interface IProps {
  file: ISessionFile;
  onDelete?: () => void;
  onClick?: () => void;
}

const LinkFileWidget: React.FC<IProps> = ({ file, onDelete, onClick }) => {
  const canPreview = Object.values(file.contentParseRes || {}).some(v => !!v);

  const handleDelete = (e: React.MouseEvent) => {
    e.stopPropagation();
    onDelete?.();
  };

  const handleClick = () => {
    onClick?.();
  };

  if (canPreview) {
    const { sourceIcon, title, desc } = file.contentParseRes!;
    return (
      <LinkPopover
        showArrow={false}
        className={styles.linkDisplay}
        onDelete={onDelete}
        onClick={onClick}
        sourceIcon={sourceIcon}
        title={title}
        desc={desc}
      />
    );
  }

  let { status, tip } = getLinkFilePreviewTip(
    file.status,
    file.contentParseStatus,
    file.contentParseRes,
  );

  return (
    <div
      className={styles.textContainer}
      onClick={status === "success" ? handleClick : () => {}}
    >
      <div className={styles.linkWrap}>
        {!status ? (
          <div className={styles.loadingBox}>
            <CircleIcon
              white
              className={cls(styles.circleLoading, "rotated")}
            />
          </div>
        ) : (
          <LinkIcon className={styles.icon} />
        )}
        <span className={styles.link}>{file.file_name}</span>
        {onDelete && (
          <DeleteIcon
            className={styles.deleteIcon}
            onClick={e => handleDelete(e)}
          />
        )}
      </div>
      {tip && status !== "success" && (
        <div
          className={cls(styles.tip, { [styles.errTip]: status === "error" })}
        >
          {tip}
        </div>
      )}
    </div>
  );
};
export default LinkFileWidget;
